import "@/App.css";
import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import { getAreaBySlug } from "@/config/eventConfig";
import { SessionProvider } from "@/hooks/useSession";
import { RightNowProvider } from "@/context/RightNowContext";
import { flushWrapQueue } from "@/lib/wrapQueue";
import { Layout } from "@/components/Layout";
import { Home } from "@/pages/Home";
import { AreaPage } from "@/pages/AreaPage";

const AreaRoute = () => {
  const { slug } = useParams();
  if (!getAreaBySlug(slug)) return <Navigate to="/" replace />;
  return (
    <Layout>
      <AreaPage key={slug} />
    </Layout>
  );
};

function App() {
  useEffect(() => {
    flushWrapQueue();
    const onOnline = () => flushWrapQueue();
    window.addEventListener("online", onOnline);
    return () => window.removeEventListener("online", onOnline);
  }, []);

  return (
    <div className="App">
      <SessionProvider>
        <BrowserRouter>
          <RightNowProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/:slug" element={<AreaRoute />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </RightNowProvider>
        </BrowserRouter>
      </SessionProvider>
    </div>
  );
}

export default App;
